import { inject } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take, filter, map, catchError, switchMap } from 'rxjs/operators';

import * as fromRoot from '../reducers';
import * as olci from '../actions/olci';
import { constants } from '../constants/constants';

export const oExpensesResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | any => {
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
    const router: Router = inject(Router);

	return store.pipe(
		select(fromRoot.getSessionVar),
		take(1),
		switchMap(sessionVars => {
			if (!sessionVars) {
				router.navigate([constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN]);
			}
			store.dispatch(new olci.ResetGuestsOnboardExpensesError());

			// Check if it is loaded already
			store.pipe(
				select(fromRoot.getOexpenseState),
				take(1)
			)
			.subscribe(data => {
				if (!data.guestsPaymentAccounts) {
					store.dispatch(new olci.LoadGuestsOnboardExpenses());
				}
			});

			return store.pipe(
				select(fromRoot.getOexpenseState),
				filter(expensesState => {
					return !!expensesState.guestsPaymentAccounts || !!expensesState.error;
				}),
				take(1),
				map(expensesState => {
					if (expensesState.error) {
						throw expensesState.error;
					}

					return true;
				}),
				catchError(error => {
					store.dispatch(new olci.NavigateToError());
					return of(false);
				})
			);
		})
	);
}
